<template>
  <div>
    <!-- Popup/Modal for validation errors and feedback -->
    <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
      <div class="popup-card">
        <div class="popup-icon-title">
          <span v-if="popupType==='warning'" class="popup-icon warning">⚠️</span>
          <span v-else class="popup-icon info">ℹ️</span>
          <span class="popup-title">{{ popupTitle }}</span>
        </div>
        <div class="popup-message">
          <span v-for="(line, idx) in popupMessage.split('\n')" :key="idx">{{ line }}<br v-if="idx < popupMessage.split('\n').length-1"/></span>
        </div>
        <button class="popup-btn" @click="closePopup">{{ $t('pages.AddHouse.got_it_5b8027f') }}</button>
      </div>
    </div>
    <!-- Main Add House Card Layout -->
    <div class="outer_box">
      <div class="all_out_box">
        <div class="tttiltleBox">
          <div class="title-container">
            <h1 class="main-title">
              <span class="icon-title">🏠</span> {{ $t('pages.AddHouse.add_a_house_91f72fd') }}
            </h1>
            <div class="title-underline"></div>
            <p class="subtitle">{{ $t('pages.AddHouse.share_a_new_student_housing_locati_03e69d1') }}</p>
          </div>
        </div>

        <div class="top_rate">
          <div class="top_rate_right">
            <div class="form-section">
              <h3 class="section-title"><span class="section-icon">📍</span> {{ $t('pages.AddHouse.address_information_477f95d') }}</h3>
              
              <div class="search-section">
                <label class="form-label">{{ $t('pages.AddHouse.search_for_existing_house_9740309') }}</label>
                <el-select
                  v-model="searchQuery"
                  class="elselect"
                  filterable
                  remote
                  :remote-method="prehandle"
                  :loading="loading"
                  :placeholder="$t('pages.AddHouse.type_to_search_address_or_place_na_a379ebd')"
                  @input="handleInput"
                  @change="handleSelectChange"
                >
                  <el-option
                    v-for="item in searchResults"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>

                <!-- "None of these" dismiss button — shown when candidates exist and user hasn't dismissed yet -->
                <div
                  v-if="dedupCandidates.length > 0 && !userDismissedCandidates && !selectedId"
                  class="dedup-none-btn-wrap"
                >
                  <button class="dedup-none-btn" @click.prevent="userDismissedCandidates = true">
                    {{ $t('pages.AddHouse.none_of_these_is_mine_create_new_h_c1b0e04') }}
                  </button>
                </div>
              </div>

              <div class="search-section autocomplete-section">
                <label class="form-label">{{ $t('pages.AddHouse.pin_exact_location_for_the_map_d58635d') }}</label>
                <div class="autocomplete-wrapper">
                  <input
                    type="text"
                    v-model="addressQuery"
                    @input="onAddressInput"
                    @focus="showAddressDropdown = addressSuggestions.length > 0"
                    :placeholder="$t('pages.AddHouse.type_a_real_address_e_g_clear_wate_29ecd02')"
                    autocomplete="off"
                    class="custom-input modern-input"
                  />
                  <div class="autocomplete-dropdown" v-if="showAddressDropdown && (addressSuggestions.length > 0 || addressSearching)">
                    <div class="autocomplete-status" v-if="addressSearching">{{ $t('pages.AddHouse.searching_1a6a5ba') }}</div>
                    <div
                      v-for="s in addressSuggestions"
                      :key="s.place_id"
                      class="autocomplete-item"
                      @click="pickAddressSuggestion(s)"
                    >
                      <div class="autocomplete-primary">{{ s.display_name }}</div>
                    </div>
                  </div>
                </div>
                <p class="pin-hint" v-if="selectedAddress">
                  {{ $t('pages.AddHouse.pinned_d14f89f') }} <strong>{{ shortAddressLabel }}</strong>
                  <span class="coords">({{ Number(selectedAddress.lat).toFixed(5) }}, {{ Number(selectedAddress.lon).toFixed(5) }})</span>
                </p>
                <p class="pin-hint" v-if="selectedAddress" style="font-size:12px;color:#666;">
                  {{ $t('pages.AddHouse.drag_the_pin_on_the_map_below_if_t_a574c10') }}
                </p>
                <p class="pin-hint" v-if="addressAutofilled" style="font-size:12px;color:#666;">
                  {{ $t('pages.AddHouse.filled_in_from_the_selected_addres_a19ab88') }}
                </p>
                <div
                  v-show="selectedAddress"
                  ref="addressPinMap"
                  class="address-pin-map"
                  style="height:280px;width:100%;margin-top:10px;border-radius:12px;overflow:hidden;border:1px solid #e3eaf2;"
                ></div>
              </div>

              <div class="input-group">
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.location_type_58cd45f') }}</label>
                  <div class="input-container">
                    <select v-model="address.locationType" class="custom-input modern-input">
                      <option value="">{{ $t('pages.AddHouse.select_location_type_710db92') }}</option>
                      <option value="On-Campus">{{ $t('pages.AddHouse.on_campus_ee963a7') }}</option>
                      <option value="Off-Campus">{{ $t('pages.AddHouse.off_campus_de6195e') }}</option>
                    </select>
                  </div>
                </div>

                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.managed_by_type_12a4cac') }}</label>
                  <div class="input-container">
                    <select v-model="address.managedByType" @change="onManagedByTypeChange" class="custom-input modern-input">
                      <option value="">{{ $t('pages.AddHouse.select_managed_by_type_8832a1e') }}</option>
                      <option value="Private Landlord">{{ $t('pages.AddHouse.private_landlord_e5b909a') }}</option>
                      <option value="Agency">{{ $t('pages.AddHouse.agency_5c47e26') }}</option>
                      <option value="University">{{ $t('pages.AddHouse.university_715432d') }}</option>
                    </select>
                  </div>
                </div>

                <div class="input-field" v-if="showManagedByName">
                  <label class="form-label">{{ $t('pages.AddHouse.managed_by_name_4763975') }}</label>
                  <div class="input-container">
                    <input
                      v-model="address.managedByName"
                      type="text"
                      :placeholder="$t('pages.AddHouse.e_g_hkust_accommodation_office_sun_58b5597')"
                      class="custom-input modern-input"
                    />
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.region_0f21717') }}</label>
                  <div class="input-container">
                    <select v-model="address.region" @change="updateDistricts" class="custom-input modern-input">
                      <option value="">{{ $t('pages.AddHouse.select_region_570539e') }}</option>
                      <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
                    </select>
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.district_c0cb139') }}</label>
                  <div class="input-container">
                    <select v-model="address.district" @change="updateAreas" class="custom-input modern-input">
                      <option value="">{{ $t('pages.AddHouse.select_district_666f30d') }}</option>
                      <option v-for="district in filteredDistricts" :key="district" :value="district">{{ district }}</option>
                    </select>
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.area_2745deb') }}</label>
                  <div class="input-container">
                    <select v-model="address.area" class="custom-input modern-input">
                      <option value="">{{ $t('pages.AddHouse.select_area_8f1f4cc') }}</option>
                      <option v-for="area in filteredAreas" :key="area" :value="area">{{ area }}</option>
                    </select>
                  </div>
                </div>

                <div class="input-field full-width">
                  <label class="form-label">{{ $t('pages.AddHouse.property_type_ad794a4') }}</label>
                  <div class="button-container">
                    <button
                      v-for="type in propertyTypes"
                      :key="type"
                      :class="{'active': address.propertyType === type, 'modern-btn': true}"
                      @click="selectPropertyType(type)"
                      class="bed-type-button"
                    >
                      {{ type }}
                    </button>
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ propertyNameLabel }}</label>
                  <div class="input-container">
                    <input 
                      v-model="address.propertyName" 
                      type="text" 
                      :placeholder="$t('pages.AddHouse.e_g_tai_po_tsai_village_625e661')" 
                      class="custom-input modern-input" 
                    />
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.street_b454109') }}</label>
                  <div class="input-container">
                    <input 
                      v-model="address.street" 
                      type="text" 
                      :placeholder="$t('pages.AddHouse.e_g_clear_water_bay_rd_56f3f57')" 
                      class="custom-input modern-input" 
                    />
                  </div>
                </div>
                
                <div class="input-field">
                  <label class="form-label">{{ $t('pages.AddHouse.address_no_24637ab') }}</label>
                  <div class="input-container">
                    <input 
                      v-model="address.addressNo" 
                      type="text" 
                      :placeholder="$t('pages.AddHouse.e_g_98_dbfc94f')" 
                      class="custom-input modern-input" 
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reviewBlock">
          <div class="newb">
            <button @click="handlePrimaryAction" class="submit-button modern-btn">
              <span class="button-text">{{ $t('pages.AddHouse.continue_ff3dbb4') }}</span>
              <span class="button-icon">→</span>
            </button>
            <p class="agreement-text">
              {{ $t('pages.AddHouse.by_continuing_i_confirm_that_i_hav_9d12334') }}
              <a href="#/terms-of-use#appendix-b" target="_blank" rel="noopener" class="agreement-link">{{ $t('pages.AddHouse.community_guidelines_7534366') }}</a>,
              <a href="#/terms-of-use" target="_blank" rel="noopener" class="agreement-link">{{ $t('pages.AddHouse.terms_of_use_9773841') }}</a>{{ $t('pages.AddHouse.and_8278d2a') }}
              <a href="#/privacy-policy" target="_blank" rel="noopener" class="agreement-link">{{ $t('pages.AddHouse.privacy_policy_9db108b') }}</a>.
            </p>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="showAddRoomModal"
      :title="$t('pages.AddHouse.add_a_room_caf6776')"
      width="420px"
      append-to-body
      :close-on-click-modal="true"
      custom-class="add-room-dialog"
      @close="closeAddRoomModal"
    >
      <div class="add-room-form">
        <div v-if="selectedId > 0" class="add-room-field">
          <label class="form-label">{{ $t('pages.AddHouse.type_to_find_your_room_6bba2e8') }}</label>
          <el-select
            v-model="roomSelection"
            class="elselect modal-room-select"
            filterable
            remote
            :remote-method="prehandle2"
            :loading="loading"
            :placeholder="$t('pages.AddHouse.type_to_find_your_room_ee10746')"
            @change="handleRoomSelectionChange"
          >
            <el-option
              key="add-room-option"
              :label="$t('pages.AddHouse.add_a_room_adce167')"
              value="__add_room__">
            </el-option>
            <el-option
              v-for="item in searchResults2"
              :key="item.id"
              :label="item.houseLetName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div v-if="selectedId > 0 && shouldShowManualRoomFields" class="add-room-field add-room-subtitle">
          <label class="form-label">{{ $t('pages.AddHouse.add_a_new_room_3b3d65d') }}</label>
        </div>

        <div v-if="shouldShowManualRoomFields" class="add-room-field">
          <label class="form-label">{{ $t('pages.AddHouse.floor_7db82f7') }} <span class="required-mark">*</span></label>
          <div class="input-container">
            <el-input
              v-model="addRoomForm.floor"
              :placeholder="$t('pages.AddHouse.e_g_gf_1f_718c4f7')"
              class="modal-text-input"
            />
          </div>
        </div>

        <div v-if="shouldShowManualRoomFields" class="add-room-field">
          <label class="form-label">{{ roomNameLabel }} <span class="required-mark">*</span></label>
          <div class="input-container">
            <el-input
              v-model="addRoomForm.roomValue"
              :placeholder="$t('pages.AddHouse.e_g_room_a_b_unit_c_3cf8567')"
              class="modal-text-input"
            />
          </div>
        </div>

        <p v-if="duplicateRoomWarning" class="add-room-duplicate-warn">⚠️ {{ duplicateRoomWarning }}</p>
        <p v-if="addRoomError" class="add-room-error">{{ addRoomError }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddRoomModal">{{ $t('pages.AddHouse.cancel_77dfd21') }}</el-button>
        <el-button v-if="isAdmin" @click="savePropertyOnly">{{ $t('pages.AddHouse.save_property_only_055ca3f') }}</el-button>
        <el-button type="primary" @click="confirmAddRoom">{{ $t('pages.AddHouse.continue_2e02623') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default Leaflet marker icon paths (webpack rewrites the asset URLs and
// breaks the default img refs, so the marker shows as a broken image otherwise).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// ALS (https://www.als.gov.hk/lookup) returns Region as a short code. Verified
// against the live API: every suggestion's EngPremisesAddress.Region is one
// of these three values.
const ALS_REGION_TO_REGION = {
  'HK': 'Hong Kong Island',
  'KLN': 'Kowloon',
  'NT': 'New Territories',
};

// ALS's EngDistrict.DcDistrict is always "<NAME> DISTRICT" in upper case, with
// "&" instead of "and" for Central & Western. Verified spelling for all 18
// districts against the live API. Keys are upper cased so lookups are
// resilient to whatever casing a given ALS response uses.
const ALS_DISTRICT_TO_DISTRICT = {
  'CENTRAL & WESTERN DISTRICT': 'Central and Western',
  'EASTERN DISTRICT': 'Eastern',
  'SOUTHERN DISTRICT': 'Southern',
  'WAN CHAI DISTRICT': 'Wan Chai',
  'YAU TSIM MONG DISTRICT': 'Yau Tsim Mong',
  'SHAM SHUI PO DISTRICT': 'Sham Shui Po',
  'KOWLOON CITY DISTRICT': 'Kowloon City',
  'KWUN TONG DISTRICT': 'Kwun Tong',
  'WONG TAI SIN DISTRICT': 'Wong Tai Sin',
  'SHA TIN DISTRICT': 'Sha Tin',
  'SAI KUNG DISTRICT': 'Sai Kung',
  'TAI PO DISTRICT': 'Tai Po',
  'NORTH DISTRICT': 'North',
  'TSUEN WAN DISTRICT': 'Tsuen Wan',
  'KWAI TSING DISTRICT': 'Kwai Tsing',
  'TUEN MUN DISTRICT': 'Tuen Mun',
  'YUEN LONG DISTRICT': 'Yuen Long',
  'ISLANDS DISTRICT': 'Islands',
};

// Roman numerals used in HK estate phase names (e.g. "PHASE I", "PHASE II")
// must not be lower-cased like ordinary words.
const ALS_ROMAN_NUMERALS = new Set([
  'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'
]);

// ALS free-text fields (street names, estate/building names) are ALL CAPS.
// Convert to natural mixed case word by word, keeping roman numerals intact
// and leaving apostrophes/digits untouched (only the first letter of each
// word is touched, so "QUEEN'S" -> "Queen's").
function alsToTitleCase(value) {
  if (!value) return value;
  return value
    .split(' ')
    .map((word) => {
      if (!word) return word;
      if (ALS_ROMAN_NUMERALS.has(word)) return word;
      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

export default {
  data() {
    return {
      isDropdownOpen: false,
      loading: false,
      selectedId:0,
      selectedHouseLetId:0,
      selectedHouse: null, // 存储选中的房屋信息
      searchQuery:'',
      searchResults: [], // 后端返回的搜索结果
      searchResults2: [], // 后端返回的搜索结果
      roomSelection: '',
      addressQuery: '',
      addressSuggestions: [],
      selectedAddress: null,
      addressSearching: false,
      showAddressDropdown: false,
      addressDebounceTimer: null,
      addressAutofilled: false, // true once a picked ALS suggestion has prefilled address fields below
      Select_District: 'Select District',
      Select_Area: 'Select Area',
      filteredDistricts: [],
      filteredAreas: [],
      regions: [
        "Hong Kong Island",
        "Kowloon",
        "New Territories"
      ],
      districts: {
        "Hong Kong Island": [
          "Central and Western",
          "Eastern",
          "Southern",
          "Wan Chai"
        ],
        "Kowloon": [
          "Yau Tsim Mong",
          "Sham Shui Po",
          "Kowloon City",
          "Kwun Tong",
          "Wong Tai Sin"
        ],
        "New Territories": [
          "Sha Tin",
          "Sai Kung",
          "Tai Po",
          "North",
          "Tsuen Wan",
          "Kwai Tsing",
          "Tuen Mun",
          "Yuen Long",
          "Islands"
        ]
      },
      areas: {
        "Central and Western": [
          "Sheung Wan",
          "Mid-Levels",
          "Sai Ying Pun",
          "Admiralty",
          "Peak",
          "Central",
          "Shek Tong Tsui",
          "Kennedy Town"
        ],
        "Eastern": [
          "Quarry Bay",
          "Sai Wan Ho",
          "Siu Sai Wan",
          "Aldrich Bay",
          "Tin Hau",
          "North Point",
          "Shau Kei Wan",
          "Chai Wan"
        ],
        "Southern": [
          "Aberdeen",
          "Ap Lei Chau",
          "Chung Hom Kok",
          "Repulse Bay",
          "Shek O",
          "Tai Tam",
          "Wong Chuk Hang",
          "Stanley",
          "Pok Fu Lam"
        ],
        "Wan Chai": [
          "Causeway Bay",
          "Happy Valley",
          "Wan Chai",
          "Tai Hang",
          "Jardine's Lookout"
        ],
        "Yau Tsim Mong": [
          "Tsim Sha Tsui",
          "King's Park",
          "West Kowloon Reclamation",
          "Tai Kok Tsui",
          "Mong Kok",
          "Yau Ma Tei",
          "Jordan"
        ],
        "Sham Shui Po": [
          "Cheung Sha Wan",
          "Yau Yat Tsuen",
          "Shek Kip Mei",
          "Mei Foo",
          "Sham Shui Po",
          "Lai Chi Kok"
        ],
        "Kowloon City": [
          "To Kwa Wan",
          "Ma Tau Kok",
          "Kai Tak",
          "Ma Tau Wai",
          "Beacon Hill",
          "Hung Hom",
          "Kowloon City",
          "Kowloon Tong",
          "Ho Man Tin"
        ],
        "Kwun Tong": [
          "Ngau Tau Kok",
          "Kowloon Bay",
          "Yau Tong",
          "Jordan Valley",
          "Kwun Tong",
          "Lam Tin"
        ],
        "Wong Tai Sin": [
          "Diamond Hill",
          "Tsz Wan Shan",
          "Ngau Chi Wan",
          "San Po Kong",
          "Wong Tai Sin",
          "Choi Hung"
        ],
        "Sha Tin": [
          "Fo Tan",
          "Ma On Shan",
          "Ma Liu Shui",
          "Sha Tin Wai",
          "Siu Lek Yuen",
          "Wu Kai Sha",
          "Sha Tin",
          "Tai Wai"
        ],
        "Sai Kung": [
          "Clear Water Bay",
          "Hang Hau",
          "Sai Kung",
          "Tiu Keng Leng",
          "Po Lam",
          "Tseung Kwan O"
        ],
        "Tai Po": [
          "Tai Po Market",
          "Tai Po",
          "Tai Wo"
        ],
        "North": [
          "Fanling",
          "Luen Wo Hui",
          "Sheung Shui",
          "Sha Tau Kok"
        ],
        "Tsuen Wan": [
          "Tsuen Wan",
          "Ma Wan",
          "Sham Tseng",
          "Lei Muk Shue"
        ],
        "Kwai Tsing": [
          "Kwai Fong",
          "Tsing Yi",
          "Kwai Chung"
        ],
        "Tuen Mun": [
          "Tuen Mun",
          "Lam Tei"
        ],
        "Yuen Long": [
          "Tin Shui Wai",
          "Ha Tsuen",
          "San Tin",
          "Hung Shui Kiu",
          "Yuen Long",
          "Kam Tin"
        ],
        "Islands": [
          "Tung Chung",
          "Mui Wo",
          "Cheung Chau",
          "Peng Chau"
        ]
      },
      address: {
        locationType: '',
        managedByType: '',
        managedByName: '',
        propertyType: '',
        region: '',
        district: '',
        area: '',
        propertyName: '',
        street: '',
        addressNo: ''
      },
      resp:'',
      room: {
        room: '',
        floor: '',
      },
      userDismissedCandidates: false,  // true after "None of these" is clicked
      dedupCandidates: [],             // soft/strong match candidates shown to user
      showAddRoomModal: false,
      addRoomForm: {
        floor: '',
        roomValue: ''
      },
      addRoomError: '',
      showPopup: false,
      popupMessage: '',
      popupTitle: '',
      popupType: 'warning', // or 'info'
      propertyTypes: ['Village House', 'Estate', 'Apartment/Building', 'Dorm', 'Studio', 'Other'],
    };
  },
  computed: {
    // A private landlord is a private individual. Publishing their name next to
    // complaints is a privacy and defamation exposure, so the field is hidden
    // rather than merely optional for that case.
    showManagedByName() {
      return this.address.managedByType !== 'Private Landlord';
    },
    propertyNameLabel() {
      const type = this.address.propertyType;
      if (type === 'Village House') return 'Village Name';
      if (type === 'Estate') return 'Estate Name';
      if (type === 'Apartment/Building') return 'Building Name';
      if (type === 'Dorm') return 'Dorm Name';
      if (type === 'Studio') return 'Studio Name';
      return 'Property Name';
    },
    roomNameLabel() {
      return this.address.propertyType === 'Estate' || this.address.propertyType === 'Apartment/Building'
        ? 'Unit'
        : 'Room';
    },
    isAdmin() {
      const token = localStorage.getItem('token');
      if (!token) return false;
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp < Date.now() / 1000) return false;
        return (payload.role || '').toLowerCase() === 'admin';
      } catch (e) { return false; }
    },
    shouldShowManualRoomFields() {
      if (this.selectedId === 0) return true;
      return !this.roomSelection || this.roomSelection === '__add_room__';
    },
    duplicateRoomWarning() {
      if (!this.shouldShowManualRoomFields) return null;
      if (!this.searchResults2.length) return null;
      const normalize = s => (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const floorNorm = normalize(this.addRoomForm.floor);
      const roomNorm = normalize(this.addRoomForm.roomValue);
      if (!floorNorm && !roomNorm) return null;
      const match = this.searchResults2.find(item => {
        const n = normalize(item.houseLetName);
        return (floorNorm && n.startsWith(floorNorm) && (!roomNorm || n.includes(roomNorm)));
      });
      return match ? `Room "${normalize(match.houseLetName)}" already exists — select it from the search above instead.` : null;
    },
    shortAddressLabel() {
      if (!this.selectedAddress) return '';
      const full = this.selectedAddress.display_name || '';
      return full.length > 70 ? full.slice(0, 67) + '…' : full;
    }
  },
  mounted() {
    // Remove SweetAlert2 test popup
  },
  methods: {
    // Clear any name already typed when switching to Private Landlord, so a value
    // entered under a previous selection cannot be submitted from a hidden field.
    onManagedByTypeChange() {
      if (this.address.managedByType === 'Private Landlord') {
        this.address.managedByName = '';
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    handleInput(value) {
      console.log('Input changed to:', value);
      // 可以在这里添加更多的逻辑，比如验证输入、触发其他操作等
    },
    handleSelectChange(value) {
      if (!value) {
        this.resetAddressForm();
        return;
      }
      // 根据选中的 name 找到对应的 item
      const selected = this.searchResults.find(item => item.name === value);
      if (selected) {
        this.selectedHouse = selected;
        this.address = {
          locationType: selected.locationType || 'Off-Campus',
          managedByType: selected.managedByType || 'Private Landlord',
          managedByName: selected.managedByName || '',
          propertyType: selected.type || '',
          region: selected.region,
          district: selected.district,
          area: selected.area,
          propertyName: selected.detailedArea,
          street: selected.street,
          addressNo: selected.address,
        };
        this.Select_District=selected.district
        this.Select_Area = selected.area
        this.selectedId = selected.id
        this.selectedHouseLetId = 0
        this.roomSelection = ''
        this.room.floor = ''
        this.room.room = ''
        this.filteredDistricts = this.districts[selected.region] || [];
        this.filteredAreas = this.areas[selected.district] || [];
        console.log('Selected House:', selected);
        this.handleSearch3(this);
      }
    },
    prehandle(query){
      this.handleSearch(this,query)
    },
    handleSearch(obj, query) {
      const normalizedQuery = (query || '').trim();
      if (!normalizedQuery) {
        obj.searchResults = [];
        obj.dedupCandidates = [];
        obj.showDropdown = false;
        return;
      }
      // Debounced autocomplete using the dedup-aware endpoint (Item 2)
      if (obj._searchDebounce) clearTimeout(obj._searchDebounce);
      obj._searchDebounce = setTimeout(function () {
        axios.get('/api/search/autocomplete-house', {
          params: {
            q: normalizedQuery,
            limit: 10
          }
        })
        .then(function (response) {
          obj.searchResults = response.data.data || [];
          obj.dedupCandidates = obj.searchResults;
          obj.userDismissedCandidates = false;
          obj.showDropdown = true;
        })
        .catch(function (error) {
          console.log(error);
          obj.searchResults = [];
          obj.dedupCandidates = [];
          obj.showDropdown = true;
        });
      }, 300);
    },
    selectPropertyType(type) {
      this.address.propertyType = type;
      this.updateFields();
    },
    resetAddressForm() {
      this.searchQuery = '';
      this.selectedHouse = null;
      this.selectedId = 0;
      this.address = {
        locationType: '',
        managedByType: '',
        managedByName: '',
        propertyType: '',
        region: '',
        district: '',
        area: '',
        propertyName: '',
        street: '',
        addressNo: ''
      };
      this.filteredDistricts = [];
      this.filteredAreas = [];
      this.Select_District = 'Select District';
      this.Select_Area = 'Select Area';
      this.searchResults2 = [];
      this.selectedHouseLetId = 0;
      this.roomSelection = '';
      this.room.floor = '';
      this.room.room = '';
    },
    updateFields() {
      console.log("yes")
    },
    handleRoomSelectionChange(value) {
      this.roomSelection = value;
      if (value && value !== '__add_room__') {
        this.selectedHouseLetId = value;
      } else {
        this.selectedHouseLetId = 0;
      }
    },
    prehandle2(query){
      this.handleSearch2(this,query)
    },
    handleSearch2(obj,query) {
      if (!this.selectedId) {
        obj.searchResults2 = [];
        return;
      }
      console.log("发送给后端search")
      console.log(query)
      console.log(this.selectedId)
      // 调用后端接口进行搜索
      axios.get('/api/search/room', {
        params: {
          keyword: query,
          houseId: this.selectedId,
          pageNo: 1,
          pageSize: 10
        }
      })
      .then(function (response) {
        console.log(obj.searchQuery)

        obj.searchResults2 = response.data.data; // 假设后端返回的是一个数组
        obj.showDropdown = true;
        console.log(obj.searchResults2)
      })
      .catch(function (error) {
        console.log(error)
        obj.searchResults2 = []; // 清空下拉选项
        obj.showDropdown = true;
      });
    },
    handleSearch3(obj) {
      console.log("发送给后端search")
      console.log(obj.selectedId)
      // 调用后端接口进行搜索
      axios.get('/api/search/room', {
        params: {
          keyword: ' ',
          houseId: obj.selectedId,
          pageNo: 1,
          pageSize: 10
        }
      })
      .then(function (response) {
        obj.searchResults2 = response.data.data; // 假设后端返回的是一个数组
        obj.showDropdown = true;
        console.log(obj.searchResults2)
      })
      .catch(function (error) {
        console.log(error)
        obj.searchResults2 = []; // 清空下拉选项
        obj.showDropdown = true;
      });
    },
    updateDistricts() {
      this.filteredDistricts = this.districts[this.address.region] || [];
      if (this.address.district) {
        this.updateAreas();
      }
    },
    updateAreas() {
      this.filteredAreas = this.areas[this.address.district] || [];
    },
    nextStep() {
      const errors = [];
      
      // Validation for address fields
      if (!this.address.locationType) {
        errors.push('Location Type is required');
      }
      if (!this.address.managedByType) {
        errors.push('Managed By Type is required');
      }
      if (this.showManagedByName && !this.address.managedByName.trim()) {
        errors.push('Managed By Name is required');
      }
      if (!this.address.region) {
        errors.push('Region is required');
      }
      if (!this.address.district) {
        errors.push('District is required');
      }
      if (!this.address.propertyType) {
        errors.push('Property Type is required');
      }
      if (!this.address.propertyName.trim()) {
        errors.push(`${this.propertyNameLabel} is required`);
      }
      if (!this.address.street.trim()) {
        errors.push('Street is required');
      }
      if (!this.address.addressNo.trim()) {
        errors.push('Address Number is required');
      }

      if (errors.length > 0) {
        this.popupTitle = 'Please Complete Required Fields';
        this.popupType = 'warning';
        this.popupMessage = errors.join('\n');
        this.showPopup = true;
        return false;
      }
      return true;
    },
    handlePrimaryAction() {
      if (!this.nextStep()) {
        return;
      }
      this.openAddRoomModal();
    },
    openAddRoomModal() {
      this.addRoomError = '';
      this.roomSelection = this.selectedHouseLetId || '';
      if (this.selectedId > 0 && this.searchResults2.length === 0) {
        this.handleSearch3(this);
      }
      this.showAddRoomModal = true;
    },
    closeAddRoomModal() {
      this.showAddRoomModal = false;
      this.addRoomError = '';
      this.addRoomForm.floor = '';
      this.addRoomForm.roomValue = '';
      this.roomSelection = this.selectedHouseLetId || '';
    },
    buildHousePayload() {
      return {
        houseId: this.selectedId,
        houseLetId: this.selectedHouseLetId,
        name: this.address.propertyName,
        locationType: this.address.locationType,
        managedByType: this.address.managedByType,
        managedByName: this.address.managedByName,
        region: this.address.region,
        district: this.address.district,
        area: this.address.area,
        detailedArea: this.address.propertyName,
        street: this.address.street,
        address: this.address.addressNo,
        houseLet: this.room.room,
        propertyType: this.address.propertyType,
        floor: this.room.floor,
        room: this.room.room,
        block: ''
      };
    },
    savePinnedLocationIfNeeded(resp, onDone) {
      if (this.selectedAddress && resp && resp.houseId) {
        axios.post('/api/location/save', {
          lat: parseFloat(this.selectedAddress.lat),
          lon: parseFloat(this.selectedAddress.lon),
          houseId: resp.houseId,
          houseLetId: resp.houseLetId,
          houseName: this.address.propertyName || ''
        })
        .then(() => onDone(resp))
        .catch(err => {
          console.error('Failed to save location:', err);
          onDone(resp);
        });
        return;
      }
      onDone(resp);
    },
    finalizeAddRoomSubmission(callback) {
      this.closeAddRoomModal();
      this.$nextTick(() => {
        callback();
      });
    },
    prepareRoomSelection() {
      if (this.selectedId > 0 && this.roomSelection && this.roomSelection !== '__add_room__') {
        this.selectedHouseLetId = this.roomSelection;
        this.room.floor = '';
        this.room.room = '';
        return true;
      }
      if (!this.addRoomForm.floor.trim()) {
        this.addRoomError = 'Floor is required.';
        return false;
      }
      if (!this.addRoomForm.roomValue.trim()) {
        this.addRoomError = `${this.roomNameLabel} is required.`;
        return false;
      }
      if (this.duplicateRoomWarning) {
        this.addRoomError = this.duplicateRoomWarning;
        return false;
      }
      this.room.floor = this.addRoomForm.floor.trim();
      this.room.room = this.addRoomForm.roomValue.trim();
      this.selectedHouseLetId = 0;
      this.roomSelection = '__add_room__';
      return true;
    },
    confirmAddRoom() {
      if (!this.prepareRoomSelection()) {
        return;
      }
      this.finalizeAddRoomSubmission(() => this.addHouse(this));
    },
    savePropertyOnly() {
      if (!this.prepareRoomSelection()) {
        return;
      }
      this.finalizeAddRoomSubmission(() => this.savePropertyOnlyAsAdmin(this));
    },
    savePropertyOnlyAsAdmin(obj) {
      axios.post('/api/house/admin/add', obj.buildHousePayload())
      .then(function (response) {
        obj.resp = response.data.data;
        obj.savePinnedLocationIfNeeded(obj.resp, obj.ToPropertyPage.bind(obj));
      })
      .catch(function (error) {
        console.log(error);
        obj.popupTitle = 'Unable to Save Property';
        obj.popupType = 'warning';
        obj.popupMessage = error?.response?.data?.msg || 'Only admin accounts can save a property without creating a review.';
        obj.showPopup = true;
      });
    },
    addHouse(obj) {
      // Enhanced validation for new house creation
      if (obj.selectedId === 0) {
        const missingFields = [];
        if (!obj.address.street?.trim()) missingFields.push('Street');
        if (!obj.address.addressNo?.trim()) missingFields.push('Address Number');
        if (!obj.address.locationType) missingFields.push('Location Type');
        if (!obj.address.managedByType) missingFields.push('Managed By Type');
        if (obj.showManagedByName && !obj.address.managedByName?.trim()) missingFields.push('Managed By Name');
        if (!obj.address.region) missingFields.push('Region');
        if (!obj.address.district) missingFields.push('District');
        if (!obj.address.propertyType) missingFields.push('Property Type');
        if (!obj.address.propertyName?.trim()) missingFields.push(this.propertyNameLabel);
        
        if (missingFields.length > 0) {
          this.popupTitle = 'Missing Information';
          this.popupType = 'warning';
          this.popupMessage = `Missing Information:\n${missingFields.map(field => `• ${field}`).join('\n')}`;
          this.showPopup = true;
          return;
        }
      }

      if (!obj.selectedHouseLetId) {
        if (!obj.room.floor?.trim() || !obj.room.room?.trim()) {
          this.popupTitle = 'Please Complete Room Details';
          this.popupType = 'warning';
          this.popupMessage = 'Please add floor and room/unit details.';
          this.showPopup = true;
          return;
        }
      }

      // 更新凭证逻辑
      console.log('Updating credentials...');
      console.log(this.selectedId)
      console.log(this.selectedHouseLetId)
      axios.post('/api/house/add', obj.buildHousePayload())
      .then(function (response) {
        console.log(response);
        obj.resp = response.data.data;
        obj.savePinnedLocationIfNeeded(obj.resp, obj.ToNextPage.bind(obj));
      })
      .catch(function (error) {
        console.log(error);
        if (error.response && error.response.status === 409) {
          const data = error.response.data;
          if (data.error === 'DUPLICATE_HOUSE') {
            obj.popupTitle = 'House Already Listed';
            obj.popupType = 'warning';
            obj.popupMessage = 'This address is already listed. Please search for it and use the existing listing.';
            obj.showPopup = true;
            // Redirect to existing house
            if (data.existingHouseId) {
              obj.$router.push({
                path: '/HouseReviewScore',
                query: { houseId: data.existingHouseId }
              });
            }
          } else if (data.error === 'DUPLICATE_ROOM') {
            obj.popupTitle = 'Room Already Exists';
            obj.popupType = 'warning';
            obj.popupMessage = 'This room already exists. You will be taken to its detail page.';
            obj.showPopup = true;
            if (data.existingHouseLetId) {
              obj.$router.push({
                path: '/HouseReviewScore',
                query: { houseLetId: data.existingHouseLetId }
              });
            }
          }
        } else {
          obj.popupTitle = 'Unable to Save';
          obj.popupType = 'warning';
          obj.popupMessage = error?.response?.data?.msg || 'Something went wrong. Please try again.';
          obj.showPopup = true;
        }
      });
    },
    ToNextPage(resp){
      if (this.$route.path !== '/rateTheHouse') {
        // Location already saved above (if provided), so force ifFirst=false
        // to bypass the legacy /AddLocation step in rateTheHouse.
        this.$router.push({
          path: '/rateTheHouse',
          query: { houseId: resp.houseId, houseLetId: resp.houseLetId, ifFirst: false }
        });
      }
    },
    ToPropertyPage(resp){
      if (this.$route.path !== '/HouseReviewScore') {
        this.$router.push({
          path: '/HouseReviewScore',
          query: { houseId: resp.houseId, houseLetId: resp.houseLetId }
        });
      }
    },
    onAddressInput() {
      this.selectedAddress = null;
      this.addressAutofilled = false;
      if (this.addressDebounceTimer) clearTimeout(this.addressDebounceTimer);
      if (!this.addressQuery || this.addressQuery.trim().length < 3) {
        this.addressSuggestions = [];
        this.showAddressDropdown = false;
        return;
      }
      this.addressDebounceTimer = setTimeout(() => this.searchAddress(this.addressQuery), 400);
    },
    searchAddress(query) {
      this.addressSearching = true;
      this.showAddressDropdown = true;
      // Hong Kong Government Address Lookup Service (ALS): free, no API key,
      // CORS-open, and it actually understands HK estate/building addresses
      // (Nominatim did not). Map every suggestion into the same
      // {display_name, lat, lon, place_id} shape the rest of this component
      // already consumes, and keep the raw ALS payload under `_als` as an
      // extra property for a later phase to use for Region/District/Street
      // autofill.
      const params = new URLSearchParams({ q: query, n: '6' }).toString();
      fetch(`https://www.als.gov.hk/lookup?${params}`, {
        headers: { 'Accept': 'application/json' }
      })
        .then(r => r.json())
        .then((data) => {
          const raw = Array.isArray(data?.SuggestedAddress) ? data.SuggestedAddress : [];
          this.addressSuggestions = raw
            .map((item) => this._mapAlsSuggestion(item))
            .filter((s) => s !== null);
          this.addressSearching = false;
        })
        .catch(() => {
          this.addressSuggestions = [];
          this.addressSearching = false;
        });
    },
    _mapAlsSuggestion(item) {
      const premises = item?.Address?.PremisesAddress;
      const eng = premises?.EngPremisesAddress;
      if (!premises || !eng) return null;

      const lat = premises.GeospatialInformation?.Latitude;
      const lon = premises.GeospatialInformation?.Longitude;
      if (lat === undefined || lat === null || lat === '' || lon === undefined || lon === null || lon === '') {
        return null;
      }

      // ALS address components vary by suggestion type (estate flat, single
      // street address, village house, commercial building, university
      // hall, etc). Every field below is optional and defensively joined.
      const block = [eng.EngBlock?.BlockDescriptor, eng.EngBlock?.BlockNo]
        .filter(Boolean).join(' ').trim();
      const buildingName = (eng.BuildingName || eng.EngBuilding?.BuildingName || '').trim();
      const estate = [eng.EngEstate?.EstateName, eng.EngEstate?.EngPhase?.PhaseName]
        .filter(Boolean).join(' ').trim();
      const street = [eng.EngStreet?.BuildingNoFrom, eng.EngStreet?.StreetName]
        .filter(Boolean).join(' ').trim();
      const location = (eng.EngStreet?.LocationName || '').trim();
      const district = (eng.EngDistrict?.DcDistrict || '').trim();
      const region = (eng.Region || '').trim();

      const displayName = [block, buildingName, estate, street, location, district, region]
        .filter(Boolean)
        .join(', ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!displayName) return null;

      return {
        display_name: displayName,
        lat,
        lon,
        place_id: premises.GeoAddress || `${lat},${lon}`,
        _als: item,
      };
    },
    pickAddressSuggestion(s) {
      this.selectedAddress = s;
      this.addressQuery = s.display_name;
      this.showAddressDropdown = false;
      this._autofillAddressFromAls(s._als);
      this.$nextTick(() => this._initOrUpdateAddressPinMap());
    },
    // Prefill the manual address fields from the raw ALS payload kept on the
    // picked suggestion under `_als`. Every field here is a *prefill*, not a
    // lock: nothing is disabled and any value the user already typed for a
    // field we can't derive is left as-is, so manual entry (the fallback for
    // buildings ALS doesn't know) keeps working exactly as before.
    _autofillAddressFromAls(als) {
      const eng = als?.Address?.PremisesAddress?.EngPremisesAddress;
      if (!eng) return;

      let autofilled = false;

      // Region and District first, in that order, using the component's own
      // cascade methods so the dependent option lists (filteredDistricts /
      // filteredAreas) repopulate exactly as if the user had picked them from
      // the dropdowns. updateDistricts() re-derives filteredDistricts from
      // address.region and, when address.district is already set, chains
      // into updateAreas() itself - so setting both values before the single
      // updateDistricts() call below makes the whole cascade stick.
      const regionCode = (eng.Region || '').trim().toUpperCase();
      const mappedRegion = ALS_REGION_TO_REGION[regionCode];
      if (mappedRegion) {
        this.address.region = mappedRegion;
        autofilled = true;
      }

      const dcDistrict = (eng.EngDistrict?.DcDistrict || '').trim().toUpperCase();
      const mappedDistrict = ALS_DISTRICT_TO_DISTRICT[dcDistrict];
      if (mappedDistrict) {
        this.address.district = mappedDistrict;
        autofilled = true;
      }

      if (mappedRegion || mappedDistrict) {
        this.updateDistricts();
      }

      // Street: name only, the building number is intentionally kept out
      // (existing data that concatenates them breaks dedup).
      const streetName = (eng.EngStreet?.StreetName || '').trim();
      if (streetName) {
        this.address.street = alsToTitleCase(streetName);
        autofilled = true;
      }

      // Address number: left as ALS returns it (e.g. "1", "1A") - these are
      // house numbers, not prose, so no case conversion is applied.
      const buildingNoFrom = (eng.EngStreet?.BuildingNoFrom || '').trim();
      if (buildingNoFrom) {
        this.address.addressNo = buildingNoFrom;
        autofilled = true;
      }

      // Property name: prefer the estate + phase, then fall back to the
      // building name (checking both shapes ALS uses for it). If neither is
      // present, leave whatever the user already has.
      const estateName = (eng.EngEstate?.EstateName || '').trim();
      const phaseName = (eng.EngEstate?.EngPhase?.PhaseName || '').trim();
      const buildingName = (eng.BuildingName || eng.EngBuilding?.BuildingName || '').trim();
      let propertyName = '';
      if (estateName) {
        propertyName = [estateName, phaseName].filter(Boolean).join(' ');
      } else if (buildingName) {
        propertyName = buildingName;
      }
      if (propertyName) {
        this.address.propertyName = alsToTitleCase(propertyName);
        autofilled = true;
      }

      // Area: ALS's LocationName is coarse (e.g. "TSEUNG KWAN O" where the
      // correct Area is the finer "Po Lam") and is frequently absent
      // altogether, so only ever set Area when it exactly matches one of the
      // Area options for the resolved district. Never guess - a silently
      // wrong prefill is worse than leaving it blank for the user to pick.
      //
      // "TSEUNG KWAN O" itself is excluded even though it is also a literal
      // Area option for Sai Kung: verified live against ALS that it returns
      // this same LocationName for buildings that are really in Po Lam/Hang
      // Hau (e.g. Metro City, which sits at Po Lam), so treating it as a
      // match would be exactly the silently-wrong prefill this rule exists
      // to avoid.
      const locationName = (eng.EngStreet?.LocationName || '').trim();
      const isTooCoarseLocationName = locationName.toUpperCase() === 'TSEUNG KWAN O';
      if (locationName && this.address.district && !isTooCoarseLocationName) {
        const candidateAreas = this.areas[this.address.district] || [];
        const match = candidateAreas.find(
          (area) => area.toLowerCase() === locationName.toLowerCase()
        );
        if (match) {
          this.address.area = match;
          autofilled = true;
        }
      }

      if (autofilled) {
        this.addressAutofilled = true;
      }
    },
    _initOrUpdateAddressPinMap() {
      const el = this.$refs.addressPinMap;
      if (!el || !this.selectedAddress) return;
      const lat = parseFloat(this.selectedAddress.lat);
      const lon = parseFloat(this.selectedAddress.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
      if (!this._addressPinMap) {
        this._addressPinMap = L.map(el, { zoomControl: true, attributionControl: false }).setView([lat, lon], 17);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(this._addressPinMap);
        this._addressPinMarker = L.marker([lat, lon], { draggable: true }).addTo(this._addressPinMap);
        this._addressPinMarker.on('dragend', (e) => {
          const ll = e.target.getLatLng();
          // Mutate selectedAddress.lat/lon so savePinnedLocationIfNeeded picks up
          // the dragged coords instead of ALS's original guess.
          this.selectedAddress = { ...this.selectedAddress, lat: ll.lat, lon: ll.lng };
        });
      } else {
        this._addressPinMap.setView([lat, lon], 17);
        this._addressPinMarker.setLatLng([lat, lon]);
        setTimeout(() => { try { this._addressPinMap.invalidateSize(); } catch (e) {} }, 0);
      }
    },
    closePopup() {
      this.showPopup = false;
    },
  },
  beforeDestroy() {
    if (this._addressPinMap) { this._addressPinMap.remove(); this._addressPinMap = null; }
    this._addressPinMarker = null;
  }
};
</script>

<style scoped>
/* Main Layout */
.outer_box {
  background: rgba(60, 194, 255, 1);
  min-height: 100vh;
  padding: 0 0 48px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.all_out_box {
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 20px 60px 0 rgba(59, 194, 255, 0.37);
  padding: 24px 36px 36px 36px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
/* Title Section */
.tttiltleBox {
  margin-bottom: 36px;
}

.title-container {
  text-align: center;
}

.main-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: #3bc2ff;
  margin-bottom: 12px;
  display: inline-block;
}

.icon-title {
  font-size: 2.2rem;
  margin: 0 4px;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: #3bc2ff;
  border-radius: 2px;
  margin: 0 auto 12px auto;
}

.subtitle {
  color: #64748b;
  font-size: 1.12rem;
  margin-bottom: 0;
}
/* Form Sections */
.top_rate {
  margin-bottom: 28px;
}

.top_rate_right {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.08);
  padding: 32px 28px;
}

.tmp_rate {
  margin-bottom: 28px;
}

.rateBlock {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.08);
  padding: 32px 28px;
}

.form-section {
  margin-bottom: 0;
}

.section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #3bc2ff;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.section-icon {
  font-size: 1.4rem;
}

/* Search Section */
.search-section {
  margin-bottom: 24px;
}
.elselect {
  width: 100%;
  max-width: 100%;
  margin-bottom: 16px;
}

.elselect >>> .el-input__inner {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 1rem;
  height: auto;
  line-height: 1.5;
  transition: all 0.3s ease;
}

.elselect >>> .el-input__inner:focus {
  border-color: #3bc2ff;
  box-shadow: 0 0 0 3px rgba(59, 194, 255, 0.1);
}

.elselect >>> .el-input__suffix {
  right: 16px;
}

.elselect >>> .el-select-dropdown__item {
  padding: 12px 16px;
  font-size: 0.95rem;
}

.elselect >>> .el-select-dropdown__item.selected {
  color: #3bc2ff;
  font-weight: 600;
}

/* Input Fields */
.input-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 0;
}

.input-field {
  flex: 1 1 calc(50% - 10px);
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-field.full-width {
  flex: 1 1 100%;
}

.form-label {
  font-weight: 600;
  color: #475569;
  font-size: 0.95rem;
  margin-bottom: 0;
}

.input-container {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.input-container:focus-within {
  border-color: #3bc2ff;
  box-shadow: 0 0 0 3px rgba(59, 194, 255, 0.1);
}

.custom-input.modern-input {
  border: none;
  outline: none;
  background: white;
  padding: 14px 16px;
  font-size: 1rem;
  color: #1e293b;
  width: 100%;
  font-family: inherit;
}

.custom-input.modern-input::placeholder {
  color: #94a3b8;
}

.input-suffix {
  color: #64748b;
  font-size: 0.9rem;
  padding-right: 16px;
  font-weight: 500;
}

.input-helper {
  margin: 8px 0 0 0;
  font-size: 0.88rem;
  color: #64748b;
  line-height: 1.4;
}

.new-address-note {
  margin-top: 0;
}

.required-mark {
  color: #ef4444;
}

.add-room-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.add-room-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.add-room-subtitle {
  margin-top: 4px;
}

.add-room-error {
  margin: 0;
  color: #ef4444;
  font-size: 0.9rem;
}

.add-room-duplicate-warn {
  margin: 0;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.9rem;
  line-height: 1.4;
}

.add-room-dialog >>> .el-dialog {
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(59, 130, 246, 0.15);
  overflow: hidden;
}

.add-room-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 24px;
  border-radius: 24px 24px 0 0;
}

.add-room-dialog >>> .el-dialog__title {
  font-size: 1.25rem;
  color: #1e40af;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.add-room-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #94a3b8;
  font-size: 18px;
}

.add-room-dialog >>> .el-dialog__body {
  padding: 24px;
  background: #fff;
}

.add-room-dialog >>> .el-dialog__footer {
  border-top: 1px solid #f1f5f9;
  padding: 16px 24px;
  background: #fafbfc;
  border-radius: 0 0 24px 24px;
}

.modal-text-input >>> .el-input__inner {
  border: none;
  height: 48px;
  line-height: 48px;
  font-size: 1rem;
  color: #1e293b;
  background: #fff;
  pointer-events: auto;
}
/* Button Container for Property Types */
.button-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.bed-type-button {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  color: #475569;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.bed-type-button:hover {
  border-color: #3bc2ff;
  color: #3bc2ff;
  transform: translateY(-2px);
}

.bed-type-button.active {
  background: #3bc2ff;
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(59, 194, 255, 0.4);
}

/* Submit Section */
.reviewBlock {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.08);
  padding: 32px 28px;
  margin-top: 0;
}

.newb {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.submit-button {
  width: 100%;
  max-width: 400px;
  padding: 18px 0;
  border: none;
  border-radius: 14px;
  background: #3bc2ff;
  color: white;
  font-weight: 700;
  font-size: 1.2rem;
  box-shadow: 0 6px 20px rgba(59, 194, 255, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.submit-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(59, 194, 255, 0.5);
}

.submit-button:active {
  transform: translateY(-1px);
}

.button-text {
  font-size: 1.15rem;
}

.button-icon {
  font-size: 1.4rem;
  transition: transform 0.3s ease;
}

.submit-button:hover .button-icon {
  transform: translateX(4px);
}

.agreement-text {
  color: #64748b;
  font-size: 0.92rem;
  margin-top: 0;
  text-align: center;
  line-height: 1.7;
  max-width: 600px;
}

.agreement-link {
  color: #3bc2ff;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s;
}

.agreement-link:hover {
  color: #3bc2ff;
  text-decoration: underline;
}
/* Mobile Responsive - Only for true mobile devices (max-width: 480px) */
@media (max-width: 480px) {
  .outer_box {
    padding: 0 0 40px 0;
  }

  .all_out_box {
    margin: 0 12px;
    padding: 24px 20px;
    border-radius: 16px;
  }

  .main-title {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .top_rate_right,
  .rateBlock,
  .reviewBlock {
    padding: 24px 18px;
    border-radius: 16px;
  }

  .section-title {
    font-size: 1.15rem;
  }

  .input-field {
    flex: 1 1 100%;
    min-width: 100%;
  }

  .button-container {
    flex-direction: column;
  }

  .bed-type-button {
    width: 100%;
  }

  .submit-button {
    max-width: 100%;
    padding: 16px 0;
    font-size: 1.1rem;
  }

  .popup-card {
    margin: 0 16px;
    padding: 28px 20px;
  }
}
/* Popup/Modal */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.popup-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(59, 194, 255, 0.3);
  padding: 36px 28px;
  min-width: 320px;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: popupSlideIn 0.3s ease;
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.popup-icon-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.popup-icon {
  font-size: 2.5rem;
}

.popup-icon.warning {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.popup-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
}

.popup-message {
  color: #475569;
  font-size: 1rem;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1.6;
}

.popup-btn {
  background: #3bc2ff;
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1.05rem;
  box-shadow: 0 4px 15px rgba(59, 194, 255, 0.4);
  padding: 12px 40px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.popup-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 194, 255, 0.5);
}

.popup-btn:active {
  transform: translateY(0);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.popup-icon-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.popup-icon {
  font-size: 2.5rem;
}

.popup-icon.warning {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.popup-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
}

.popup-message {
  color: #64748b;
  font-size: 0.95rem;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1.6;
}

.popup-btn {
  background: linear-gradient(135deg, #3bc2ff 0%, #0284c7 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.3);
  padding: 12px 32px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.popup-btn:hover {
  background: linear-gradient(135deg, #0284c7 0%, #075985 100%);
  box-shadow: 0 6px 20px rgba(59, 194, 255, 0.4);
  transform: translateY(-2px);
}

.popup-btn:active {
  transform: translateY(0);
}

.autocomplete-section {
  position: relative;
  margin-top: 16px;
}

.autocomplete-wrapper {
  position: relative;
}

.autocomplete-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  z-index: 20;
  max-height: 320px;
  overflow-y: auto;
}

.autocomplete-status {
  padding: 12px 16px;
  color: #94a3b8;
  font-size: 0.9rem;
}

.autocomplete-item {
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.autocomplete-item:last-child {
  border-bottom: none;
}

.autocomplete-item:hover {
  background: #f0f9ff;
}

.autocomplete-primary {
  font-size: 0.95rem;
  color: #0f172a;
  line-height: 1.35;
}

.pin-hint {
  margin-top: 10px;
  padding: 10px 14px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #065f46;
}

.pin-hint .coords {
  color: #047857;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.82rem;
  margin-left: 6px;
}

/* Dedup "None of these" button */
.dedup-none-btn-wrap {
  margin-top: 10px;
}
.dedup-none-btn {
  background: none;
  border: 1px dashed #3bc2ff;
  color: #3bc2ff;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 0.92rem;
  cursor: pointer;
  transition: background 0.15s;
}
.dedup-none-btn:hover {
  background: #ecf9ff;
}
</style>
